import { useCallback } from 'react';
import { useCategories } from '@/hooks/useSharedData';
import { activityPath } from '@/lib/activityUrl';

// Stable identity for the "no categories yet" case, so the resolver below keeps
// its identity across renders instead of rebuilding effects that depend on it.
const NO_CATEGORIES = [];

/**
 * Resolves the canonical path of an activity: `to(activity)`.
 *
 * The categories come from the shared cache. A caller that already loaded them
 * (a landingpage, the planner) passes its own list so the path matches the data
 * it is displaying.
 */
export default function useActivityPath(categories) {
  const { data } = useCategories();
  const list = categories?.length ? categories : (data || NO_CATEGORIES);

  return useCallback((activity) => activityPath(activity, list), [list]);
}